import Logo from '@alltrails/shared/denali/components/Logo';
import { wrapUrlSafe } from '@alltrails/shared/utils/languageSupport';
import useLanguageRegionCode from '@alltrails/shared/hooks/useLanguageRegionCode';
import * as styles from './MinimalHeader.module.scss';

export default function MinimalHeader() {
  const languageRegionCode = useLanguageRegionCode();

  return (
    <header className={styles.header}>
      <a href={wrapUrlSafe('/', languageRegionCode)}>
        <Logo size="sm" color="colored-dark" variant="logomark" />
      </a>
    </header>
  );
}
